export function parseSeparators(_ref) {
  var decimalSeparator = _ref.decimalSeparator,
    thousandSeparator = _ref.thousandSeparator;
  var map = {
    comma: ',',
    space: ' ',
    period: '.'
  };
  return {
    decimal: map[decimalSeparator] || null,
    thousands: map[thousandSeparator] || null
  };
}